module.exports = __webpack_public_path__ + "static/media/debit-card.42cefcc9.svg";